import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Constants, ICountry, ILookup, NewAccountEntityType, NewAccountType, PrsOrganisationType } from 'common';
import { Subscription } from 'rxjs';
import { AccountRegistrationService } from '../../../services/account-registration.service';
import { validationGroup } from '../constants/registration.constants';

@Component({
  selector: 'acc-registration-general-details',
  templateUrl: './general-details.component.html',
  styleUrl: './general-details.component.scss',
})
export class GeneralDetailsComponent implements OnInit {
  NewAccountEntityType = NewAccountEntityType;
  NewAccountType = NewAccountType;
  private subscription = new Subscription();
  validationGroup = validationGroup;

  accountType: NewAccountType;
  registrationNumberMandatory: boolean = false;
  isCharity: boolean = false;

  salutations: ILookup[];
  countries: ICountry[];
  counties: ILookup[];
  organisationTypes: ILookup[];

  showCompanyFields = true;

  get formGeneralDetails() {
    return this.accountRegistrationService.formGeneralDetails;
  }

  get isPrs() {
    return this.accountType === NewAccountType.Prs;
  }

  get isRadio() {
    return this.accountType === NewAccountType.Radio;
  }

  emailIsReadOnly = false;

  constructor(
    private readonly accountRegistrationService: AccountRegistrationService,
    private route: ActivatedRoute
  ) {
    //if, for some reason, no email has been pulled from the logged in user then allow the field to be edited.
    this.emailIsReadOnly = this.formGeneralDetails.controls.email && this.formGeneralDetails.controls.email?.value?.length > 0;
  }

  ngOnInit(): void {
    this.salutations = this.route.snapshot.data.salutations;
    this.countries = this.route.snapshot.data.countries;
    this.counties = this.route.snapshot.data.counties;
    this.organisationTypes = this.route.snapshot.data.prsOrganisationTypes;

    this.registerAccountTypeListener();
    this.registerEntityTypeListener();
  }

  showHeaderError = (group: string[]): boolean =>
    group.some((prop) => {
      const control = this.formGeneralDetails?.get(prop);
      return control?.invalid && control?.touched;
    });

  registerAccountTypeListener(): void {
    this.subscription.add(
      this.accountRegistrationService.accountType$.subscribe((accountType: NewAccountType) => {
        this.accountType = accountType;

        if (this.accountType === NewAccountType.Prs) {
          this.accountRegistrationService.setEntityType(NewAccountEntityType.Company);
          this.formGeneralDetails.controls.entityType.disable();
          this.formGeneralDetails.controls.orgType.enable();
          this.formGeneralDetails.controls.regNumber.enable();
        } else if (this.accountType === NewAccountType.Radio) {
          this.formGeneralDetails.controls.entityType.enable();
          this.formGeneralDetails.controls.orgType.disable();
          this.formGeneralDetails.controls.regNumber.disable();
        }
      })
    );
  }

  registerEntityTypeListener(): void {
    this.subscription.add(
      this.accountRegistrationService.entityType$.subscribe((entityType: NewAccountEntityType) => {
        this.showCompanyFields = entityType !== NewAccountEntityType.Person;
      })
    );
  }

  onEntityChange(value: string) {
    this.accountRegistrationService.setEntityType(<NewAccountEntityType>value);
  }

  countryChanged(value: string) {
    if (value.toLowerCase() === Constants.irelandCountryString.toLocaleLowerCase()) {
      this.formGeneralDetails.controls.county.enable();
    } else {
      this.formGeneralDetails.controls.county.setValue(null);
      this.formGeneralDetails.controls.county.disable();
    }
  }

  orgTypeChange(value) {
    this.registrationNumberMandatory = value === PrsOrganisationType.LimitedCompany || value === PrsOrganisationType.Charity;
    this.isCharity = value === PrsOrganisationType.Charity;
    this.accountRegistrationService.setPrsOrgType(value);

    const regNumber = this.formGeneralDetails.get('regNumber');
    if (regNumber !== null) {
      regNumber.clearValidators();
      if (value === PrsOrganisationType.LimitedCompany) {
        //company
        regNumber.addValidators(Validators.required);
      }
      if (value === PrsOrganisationType.Charity) {
        //charity
        regNumber.addValidators([Validators.pattern('^CHY.*$'), Validators.required]);
      }
      regNumber.updateValueAndValidity();
    }
  }
}
